import { useState } from "react";
import { BookOpen } from "lucide-react";
import { Reveal } from "./Reveal";
import { useSite } from "../context/SiteContext";

export default function SemesterSubjects() {
  const { semesters } = useSite();
  const [active, setActive] = useState(0);
  if (!semesters || semesters.length === 0) return null;

  const current = semesters[Math.min(active, semesters.length - 1)];

  return (
    <section data-testid="semester-section" className="bg-forest text-bone py-24 md:py-36 relative overflow-hidden grain">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 relative z-10">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-gold mb-4">FYUP Curriculum</p>
          <h2 className="font-serif text-4xl md:text-6xl tracking-tight leading-none">Subjects by Semester</h2>
          <p className="text-bone/50 mt-5 max-w-xl">
            Browse the papers offered across all eight semesters of the Four Year Undergraduate Programme.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-12 gap-8">
          {/* semester selector */}
          <div className="lg:col-span-4">
            <div className="grid grid-cols-4 lg:grid-cols-2 gap-2">
              {semesters.map((s, i) => (
                <button
                  key={s.id || i}
                  data-testid="semester-tab"
                  onClick={() => setActive(i)}
                  className={`px-4 py-3 rounded-sm text-sm uppercase tracking-widest border transition-colors ${
                    i === active ? "bg-gold text-forest border-gold" : "border-bone/20 text-bone/70 hover:border-gold hover:text-bone"
                  }`}
                >
                  {s.semester.replace("Semester ", "Sem ")}
                </button>
              ))}
            </div>
          </div>

          {/* subject panel */}
          <div className="lg:col-span-8">
            <Reveal key={current.id || active}>
              <div data-testid="semester-panel" className="bg-forest-900/40 border border-bone/15 rounded-sm p-8 md:p-10">
                <div className="flex items-baseline justify-between flex-wrap gap-3 mb-8">
                  <h3 className="font-serif text-3xl md:text-4xl text-gold-light">{current.semester}</h3>
                  {current.program && <span className="text-xs uppercase tracking-widest text-bone/50">{current.program}</span>}
                </div>
                <ul className="space-y-4">
                  {(current.subjects || []).map((sub, i) => (
                    <li key={i} data-testid="semester-subject" className="flex items-start gap-4 border-b border-bone/10 pb-4 last:border-0">
                      <BookOpen size={18} className="text-gold shrink-0 mt-0.5" />
                      <span className="text-bone/90 text-lg">{sub}</span>
                    </li>
                  ))}
                  {(!current.subjects || current.subjects.length === 0) && (
                    <li className="text-bone/50">Subjects for this semester will be updated soon.</li>
                  )}
                </ul>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
